export { TabbedModal } from './tabbed-modal';
export type { TabConfig, TabbedModalProps } from './tabbed-modal'; 